var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.modifiedItems),function(rating,index){return _c('rating-preview',{key:rating.id,attrs:{"rating":rating,"prevRating":_vm.items[index - 1],"index":index,"perPage":_vm.perPage}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }